<script>
import emailRenderer from '@/views/components/renderers/email-renderer'

export default {
  components: {
    emailRenderer
  },
  computed: {
    value() {
      return this.params.getValue();
    }
  }
};
</script>

<template>
  <email-renderer :value="value">
   
  </email-renderer>
</template>
